import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RegistrationNavigationLoaderService {
  private readonly activeSubject = new BehaviorSubject(false);
  readonly active$ = this.activeSubject.asObservable();

  show(): void { this.activeSubject.next(true); }
  hide(): void { this.activeSubject.next(false); }
}
